<template>
    <div>
      <b-modal
        id="modal-editar-hsm"
        v-model="showEditModal"
        title="Editar HSM"
        @ok="saveEditHsm"
        ok-title="Salvar"
        cancel-title="Cancelar"
      >
        <div v-if="editObj">
          <div class="form-group">
            <label>Nome HSM</label>
            <input v-model="editObj.hsmName" class="form-control" />
          </div>
          <div class="form-group">
            <label>Texto HSM</label>
            <textarea v-model="editObj.hsmText" class="form-control" rows="3"></textarea>
          </div>
          <div v-if="editObj.provedor === 'NXZAP'">
            <div class="form-group d-flex align-items-center">
              <label class="mb-0 mr-2">Imagem no Cabeçalho</label>
              <input type="checkbox" v-model="editObj.hasImage" style="width:18px;height:18px;" />
            </div>
            <div class="form-group" v-if="editObj.hasImage">
              <label>Código da Imagem</label>
              <div class="input-group">
                <input v-model="editObj.hsmImageId" class="form-control" placeholder="Código da imagem" />
                <div class="input-group-append">
                  <button class="btn btn-secondary btn-sm" @click.prevent="onGenerateImageId">Gerar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </b-modal>
      <div class="animated fadeIn">
        <Tables
          ref="tableGrid"
          :columns="[
            'ID',
            'Nome HSM',
            'Data Criação',
            'Texto HSM',
            $lang.Common.DataTable.Actions
          ]"
          :showNew="true"
          :showSearch="false"
          :showReload="true"
          :showTipFooter="false"
          v-on:New="onNew"
          v-on:Load="onLoad"
          v-on:Reload="onLoad"
        >
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn
              :IsText="true"
              v-on:Edit="onEdit(obj)"
              :status="obj.inative ? 0 : 1"
              :value="obj.hsmId ? obj.hsmId : '-'"
            />
            <TableColumn
              :IsText="true"
              v-on:Edit="onEdit(obj)"
              :status="obj.inative ? 0 : 1"
              :value="
                obj.hsmName
                  ? obj.hsmName
                  : '-'
              "
            />
            <TableColumn
              :IsDatetime="true"
              v-on:Edit="onEdit(obj)"
              :status="obj.inative ? 0 : 1"
              :value="obj.createdAt ? obj.createdAt : '-'"
            />
            <TableColumn
              :IsText="true"
              v-on:Edit="onEdit(obj)"
              :status="obj.inative ? 0 : 1"
              :value="
                obj.hsmText
                  ? verificarTamanho(obj.hsmText)
                  : ''
              "
            />
            <TableColumn
              :IsActionsButtons="true"
              :HasChange="false"
              v-on:Delete="onDelete(obj)"
              v-on:Edit="onEdit(obj)"
              :status="obj.status"
              editButtonClass="btn btn-secondary btn-sm"  
            />
          </tr>
        </Tables>

        <div class="row">
          <div class="col-12 pb-3 pl-4">
            <button
              type="button"
              class="btn btn-third btn-sm"
              v-on:click="$emit('New')"
              v-b-tooltip.hover
              :title="'Clique para cadastrar'"
            >
              <i class="fas fa-user-plus"></i>
              <span class="d-md-down-none">&nbsp; Novo</span>
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import HsmRepository from '@/shared/http/repositories/configurations/hsm.js'

export default {
  name: 'ListaHsm',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      showEditModal: false,
      editObj: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onEdit (obj) {
      // Abre o modal de edição com os dados do HSM selecionado
      this.editObj = { ...obj }
      this.showEditModal = true
    },

    saveEditHsm () {
      this.editHsm(this.editObj)
      this.showEditModal = false
    },

    editHsm (obj) {
      loading.push()
      HsmRepository.Update(obj.id, obj)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onLoadAll () {
      loading.push()
      HsmRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(this.onResultGrid)
        .catch(this.onException)
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      HsmRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    createdAtEqualUpdatedAt (createdAt, updatedAt) {
      const date1 = new Date(createdAt)
      const date2 = new Date(updatedAt)

      if (date1.getTime() === date2.getTime()) {
        return ''
      }
      return updatedAt
    },
    verificarTamanho (texto) {
      if (texto.length <= 20) {
        return texto
      } else {
        return texto.slice(0, 97) + '...'
      }
    }
    // ...existing code...

  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/hsm/components/list/ListaHsm.vue